import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import { useCart } from "../components/contexts/CartContext";
import { useGeneral } from "../components/contexts/GeneralContext";
import axios from "../config/axios";
import { useToast } from "../components/contexts/ToastContext";
import GeneralButton from "../components/common/GeneralButton";
import { AiFillCheckCircle } from "react-icons/ai";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import {
  useChildDetails,
  useDate,
  useDisclaimer,
  useKid,
  useMealsSelection,
  useMealType,
  useStep,
} from "../components/contexts/SubscriptionContext";
import { MdError } from "react-icons/md";

const PaymentReceivedPage = () => {
  const { type, status, id } = useParams();
  const { discountCoupons } = useGeneral();
  const { setSelectedMealType } = useMealType();
  const { clearMeals } = useMealsSelection();
  const { setSelectedKidId } = useKid();
  const { clearChildDetails } = useChildDetails();
  const { resetDisclaimer } = useDisclaimer();
  const { fetchCart } = useCart();
  const { addToast } = useToast();
  const { goToStep } = useStep();
  const location = useLocation();
  const { setSelectedDate } = useDate();
  const params = new URLSearchParams(location.search);
  const renew = params.get("renew");
  const navigate = useNavigate();
  useEffect(() => {
    goToStep("6");
    if (status === "success") {
      localStorage.removeItem("promoCodeSaved");
      localStorage.removeItem("selectedCity");
      fetchCart();
    }
    if (type === "meals" && status === "success") {
      localStorage.removeItem("selectedPlanNew");
      localStorage.removeItem("sessionStarted");
      localStorage.removeItem("selectedMealTypeNew");
      localStorage.removeItem("selectedChildNew");
      localStorage.removeItem("selectedMealsNew");
      localStorage.removeItem("childDetailsNew");
      localStorage.removeItem("mealCartId");
      localStorage.removeItem("acceptedDisclaimerNew");
      localStorage.removeItem("subscriptionStartDate");
      localStorage.removeItem("selectedDateNew");
      setSelectedMealType(null);
      setSelectedDate(null);
      setSelectedDate(null);
      clearMeals();
      clearChildDetails();
      resetDisclaimer();
    }
    if (renew) {
      localStorage.removeItem("renewSessionStarted");
    }
  }, [type, status]);

  return (
    <PageWrapper loading={false}>
      <Header code={discountCoupons} />
      <BodyWrapper className="">
        {status === "success" && id && type === "meals" && renew != "true" && (
          <TopStepsStatus rightText="" url="" />
        )}

        <div className="grid grid-cols-1 2.5xl:grid-cols-1">
          <div className="flex flex-col items-start justify-start">
            {status === "success" && id && type === "order" && (
              <>
                <motion.div
                  initial={{ x: -200, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: -200, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                >
                  <p className="text-32pt md:text-34pt pb-4 lg:pb-9">
                    Order Placed Successfuly
                  </p>
                  <div
                    className={
                      "grid grid-cols-1 lg:grid-cols-1 2xl:grid-cols-[5fr_1fr] gap-8 items-start"
                    }
                  >
                    <div>
                      <div className="bg-secondary  w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[80px] mb-10">
                        <div
                          className={
                            "grid grid-cols-1 lg:grid-cols-[3.5fr_1fr] 2.5xl:grid-cols-[4.5fr_1fr] gap-3 md:gap-10 2.5xl:gap-28 mt-0"
                          }
                        >
                          <div className="rounded-[15px] p-5 flex flex-col justify-between order-2 lg:order-1">
                            <div className="w-full">
                              <p className="text-white text-28pt md:text-48pt leading-none mb-10">
                                Thank you!
                              </p>
                              <p className="text-white text-28pt md:text-30pt leading-none mb-2">
                                Your order has been received and will be
                                processed soon.
                              </p>

                              <p className="text-white text-28pt md:text-30pt leading-tight mb-2">
                                Your order number is:{" "}
                                <span className="text-quaternary">"{id}"</span>
                              </p>
                              <div className="text-orange text-21pt leading-tight mt-6">
                                <p>
                                  We have sent an invoice with your order's
                                  details to your registered email address.
                                </p>
                                <p className="mt-2">
                                  If you do not receive it within a few minutes,
                                  check your Bulk Mail / Spam / Junk folders.
                                </p>
                                <p className="mt-2">
                                  For any queries, kindly{" "}
                                  <Link
                                    to="/contact"
                                    className="text-orange underline"
                                  >
                                    Contact us
                                  </Link>
                                </p>
                              </div>

                              <GeneralButton
                                title="Click to view products"
                                text="Continue Shopping"
                                textColor="#fff"
                                className="text-21pt mt-6"
                                onClick={() => navigate("/shop")}
                              />
                            </div>
                          </div>
                          <div className="flex items-center justify-center order-1 lg:order-2">
                            <img
                              src={require("../assets/images/success.png")}
                              className="w-[134px] h-[134px] mt-10 lg:mt-20"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </>
            )}
            {status === "success" &&
              id &&
              type === "meals" &&
              renew != "true" && (
                <>
                  <motion.div
                    initial={{ x: -200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -200, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                  >
                    <p className="text-32pt md:text-34pt pb-4 lg:pb-9 mt-4 lg:mt-9">
                      Meal Subscription Successful
                    </p>
                    <div
                      className={
                        "grid grid-cols-1 lg:grid-cols-1  2xl:grid-cols-[5fr_1fr] 2.5xl:grid-cols-[3.4fr_1fr] gap-8 items-start"
                      }
                    >
                      <div>
                        <div className="bg-secondary  w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[80px] mb-10">
                          <div
                            className={
                              "grid grid-cols-1 lg:grid-cols-[2.5fr_1fr] 2.5xl:grid-cols-[2.5fr_1fr] gap-3 md:gap-10 2.5xl:gap-28 mt-0"
                            }
                          >
                            <div className="rounded-[15px] p-5 flex flex-col justify-between order-2 lg:order-1">
                              <div className="w-full">
                                <p className="text-white text-28pt md:text-48pt leading-none mb-10 text-center lg:text-left">
                                  Thank you for choosing us to nourish your
                                  child.{" "}
                                </p>
                                <p className="text-orange text-28pt md:text-[35px] 2xl:text-48pt text-center lg:text-left leading-none">
                                  Your meal plan is now active, and you can
                                  manage everything from your dashboard.
                                </p>
                                <p className="text-orange text-[20px]  leading-tight text-center lg:text-left mt-4 xl:mt-8">
                                  Please wait, you'll be redirected to the
                                  dashboard soon.
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center justify-center order-1 lg:order-2">
                              <img
                                src={require("../assets/images/success.png")}
                                className="w-[134px] h-[134px] mt-10 lg:mt-20"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </>
              )}
            {status === "success" &&
              id &&
              type === "meals" &&
              renew === "true" && (
                <>
                  <motion.div
                    initial={{ x: -200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -200, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                  >
                    <p className="text-32pt md:text-34pt pb-4 lg:pb-8">
                      Meal Subscription Renewal Successful
                    </p>
                    <div
                      className={
                        "grid grid-cols-1 lg:grid-cols-1  2xl:grid-cols-[5fr_1fr] 2.5xl:grid-cols-[3.4fr_1fr] gap-8 items-start"
                      }
                    >
                      <div>
                        <div className="bg-secondary  w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[80px] mb-10">
                          <div
                            className={
                              "grid grid-cols-1 lg:grid-cols-[2.5fr_1fr] 2.5xl:grid-cols-[2.5fr_1fr] gap-3 md:gap-10 2.5xl:gap-28 mt-0"
                            }
                          >
                            <div className="rounded-[15px] p-5 flex flex-col justify-between order-2 lg:order-1">
                              <div className="w-full">
                                <p className="text-white text-28pt md:text-48pt leading-none mb-10 text-center lg:text-left">
                                  Thank you for choosing us to nourish your
                                  child.{" "}
                                </p>
                                <p className="text-orange text-28pt md:text-[35px] 2xl:text-48pt text-center lg:text-left leading-none">
                                  Your meal plan is renewed and now active, and
                                  you can manage everything from your dashboard.
                                </p>
                                <p className="text-orange text-[20px]  leading-tight text-center lg:text-left mt-4 xl:mt-8">
                                  Please wait, you'll be redirected to the
                                  dashboard soon.
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center justify-center order-1 lg:order-2">
                              <img
                                src={require("../assets/images/success.png")}
                                className="w-[134px] h-[134px] mt-10 lg:mt-20"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </>
              )}
            {status === "failed" && type === "order" && (
              <motion.div
                initial={{ x: -200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -200, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
              >
                <div className="grid grid-cols-1 lg:grid-cols-1 2xl:grid-cols-[3.4fr_1fr] gap-8 items-start">
                  <div>
                    <p className="text-32pt md:text-34pt pb-4 lg:pb-9">
                      Order placing was not successful
                    </p>
                    <div className="bg-secondary w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[80px] mb-10">
                      <div className="grid grid-cols-1 lg:grid-cols-[2.5fr_1fr] 2.5xl:grid-cols-[2.5fr_1fr] gap-3 md:gap-10 2.5xl:gap-28 mt-0">
                        <div className="rounded-[15px] p-5 flex flex-col justify-between order-2 lg:order-1">
                          <div className="w-full">
                            <p className="text-white text-28pt md:text-48pt leading-none mb-10">
                              Your order could not be placed
                            </p>
                            <p className="text-orange text-28pt md:text-[35px] 2xl:text-48pt leading-none">
                              Please contact the administrator for more details
                              or assistance.
                            </p>
                            <p className="text-orange mt-2">
                              For any queries, kindly{" "}
                              <Link
                                to="/contact"
                                className="text-orange underline"
                              >
                                Contact us
                              </Link>
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center justify-center order-1 lg:order-2">
                          <motion.div
                            className="text-6xl text-orange mb-3"
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{
                              type: "spring",
                              stiffness: 300,
                              damping: 15,
                            }}
                          >
                            <MdError size={180} />
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
            {status === "failed" && type === "meals" && (
              <motion.div
                initial={{ x: -200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -200, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
              >
                <div className="grid grid-cols-1 lg:grid-cols-1 2xl:grid-cols-[3.4fr_1fr] gap-8 items-start">
                  <div>
                    <p className="text-32pt md:text-34pt pb-4 lg:pb-9">
                      Meal Subscription was not successful
                    </p>
                    <div className="bg-secondary w-full rounded-[15px] p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[80px] mb-10">
                      <div className="grid grid-cols-1 lg:grid-cols-[2.5fr_1fr] 2.5xl:grid-cols-[2.5fr_1fr] gap-3 md:gap-10 2.5xl:gap-28 mt-0">
                        <div className="rounded-[15px] p-5 flex flex-col justify-between order-2 lg:order-1">
                          <div className="w-full">
                            <p className="text-white text-28pt md:text-48pt leading-none mb-10">
                              Your Subscription could not be placed
                            </p>
                            <p className="text-orange text-28pt md:text-[35px] 2xl:text-48pt leading-none">
                              Please contact the administrator for more details
                              or assistance.
                            </p>
                            <p className="text-orange mt-2">
                              For any queries, kindly{" "}
                              <Link
                                to="/contact"
                                className="text-orange underline"
                              >
                                Contact us
                              </Link>
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center justify-center order-1 lg:order-2">
                          <motion.div
                            className="text-6xl text-orange mb-3"
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{
                              type: "spring",
                              stiffness: 300,
                              damping: 15,
                            }}
                          >
                            <MdError size={180} />
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </BodyWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default PaymentReceivedPage;
